import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotateFreeSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M89.31,60,84.75,89.15l-48-7.5,2.16-13.81,25.57,4c3.9.61,12.46-13.77,17.53-13Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M54,40.83,60.3,53.28,37.24,65c-3.52,1.79-2,18.45-6.6,20.78l-6.56,3.34L10.68,62.87Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M90.22,59.35a1.16,1.16,0,0,0-.73-.45l-7.28-1.14c-3.27-.52-7.11,3.52-10.82,7.43-2.18,2.28-5.45,5.79-6.71,5.55l-25.57-4a1.15,1.15,0,0,0-.84.21,1.1,1.1,0,0,0-.44.73L35.67,81.48a1.12,1.12,0,0,0,.2.83,1.15,1.15,0,0,0,.74.45,1.13,1.13,0,0,0,1.28-.94l2-12.69L64.34,73c2.4.37,5.31-2.69,8.69-6.24,3-3.15,6.71-7.06,8.84-6.74L88,61,83.64,89a1.13,1.13,0,0,0,.21.83,1,1,0,0,0,.72.45h.18a1.1,1.1,0,0,0,1.11-.94l4.56-29.15A1.08,1.08,0,0,0,90.22,59.35Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M37.75,66l16-8.13c4.82-2.45,6.49-3.3,7.07-3.68l0,.06a1.11,1.11,0,0,0,.49-1.51L55,40.32a1.11,1.11,0,0,0-.66-.56,1.09,1.09,0,0,0-.85.07A1.13,1.13,0,0,0,53,41.34l5.83,11.45L36.73,64c-2.17,1.1-2.71,5.08-3.39,10.12-.58,4.32-1.3,9.69-3.21,10.66l-5.56,2.83L11.69,62.36A1.11,1.11,0,0,0,11,61.8a1.09,1.09,0,0,0-.85.07,1.06,1.06,0,0,0-.56.65,1.12,1.12,0,0,0,.06.86l13.4,26.28a1.09,1.09,0,0,0,.65.56,1,1,0,0,0,.35,0,1.13,1.13,0,0,0,.51-.12h0l.26-.13,6.29-3.21c3-1.51,3.71-7,4.43-12.36C36,71.14,36.63,66.6,37.75,66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M46.83,81.88l-3.28-.52A1.33,1.33,0,0,0,42,82.47,1.32,1.32,0,0,0,43.14,84l3.28.51.2,0a1.33,1.33,0,0,0,.21-2.64Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M53.39,82.9l-3.28-.51a1.33,1.33,0,0,0-1.52,1.11,1.3,1.3,0,0,0,.24,1,1.38,1.38,0,0,0,.87.53l3.28.51.21,0a1.33,1.33,0,0,0,1.31-1.13,1.33,1.33,0,0,0-1.11-1.52Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M60,83.93l-3.28-.52a1.39,1.39,0,0,0-1,.24,1.38,1.38,0,0,0-.53.87A1.33,1.33,0,0,0,56.26,86l3.28.52h.21a1.33,1.33,0,0,0,.2-2.64Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M40.27,80.85,37,80.34a1.33,1.33,0,0,0-1.52,1.11A1.35,1.35,0,0,0,36.57,83l3.28.51h.21a1.33,1.33,0,0,0,.21-2.64Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M85,87.84l-2-.32a1.32,1.32,0,0,0-1.52,1.11,1.3,1.3,0,0,0,.24,1,1.38,1.38,0,0,0,.87.53l2,.32h.2a1.33,1.33,0,0,0,1.32-1.12,1.35,1.35,0,0,0-.24-1A1.3,1.3,0,0,0,85,87.84Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M79.64,87l-3.29-.52a1.33,1.33,0,0,0-.4,2.63l3.28.51.2,0A1.33,1.33,0,0,0,79.64,87Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M73.08,86l-3.29-.51a1.32,1.32,0,0,0-1.51,1.1,1.33,1.33,0,0,0,1.1,1.52l3.29.52h.2a1.33,1.33,0,0,0,1.32-1.12,1.35,1.35,0,0,0-.25-1A1.26,1.26,0,0,0,73.08,86Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M66.51,85l-3.28-.51a1.33,1.33,0,1,0-.41,2.63l3.28.51.21,0a1.33,1.33,0,0,0,.2-2.65Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M12.94,60.66a1.34,1.34,0,0,0-1,.08l-1.84.94a1.33,1.33,0,0,0,.61,2.52,1.3,1.3,0,0,0,.6-.15l1.84-.94a1.33,1.33,0,0,0-.19-2.45Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M17.84,57.73l-3,1.51a1.32,1.32,0,0,0-.66.77,1.33,1.33,0,0,0,1.27,1.74,1.36,1.36,0,0,0,.6-.14l3-1.51a1.32,1.32,0,0,0,.66-.77,1.33,1.33,0,0,0-1.87-1.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M39.16,49.69a1.36,1.36,0,0,0,.6-.14l3-1.51a1.33,1.33,0,1,0-1.2-2.37l-3,1.51a1.33,1.33,0,0,0,.6,2.51Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M45.08,46.68a1.39,1.39,0,0,0,.6-.14l3-1.51a1.32,1.32,0,0,0,.58-1.79,1.29,1.29,0,0,0-.77-.66,1.34,1.34,0,0,0-1,.08l-3,1.5a1.33,1.33,0,0,0,.61,2.52Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M37.39,49.27a1.33,1.33,0,0,0-1.79-.58l-3,1.5a1.33,1.33,0,1,0,1.21,2.37l3-1.5A1.34,1.34,0,0,0,37.39,49.27Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M55.14,40.22a1.32,1.32,0,0,0-.77-.66,1.34,1.34,0,0,0-1,.08l-3,1.51a1.36,1.36,0,0,0-.66.77A1.34,1.34,0,0,0,51,43.67a1.27,1.27,0,0,0,.6-.15l3-1.51A1.34,1.34,0,0,0,55.14,40.22Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M29.68,51.7l-3,1.51a1.33,1.33,0,0,0,.6,2.51,1.43,1.43,0,0,0,.61-.14l3-1.51a1.32,1.32,0,0,0,.66-.77,1.33,1.33,0,0,0-1.87-1.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M24.77,54.64a1.23,1.23,0,0,0-1,.08l-3,1.5A1.34,1.34,0,0,0,20.22,58a1.33,1.33,0,0,0,1.19.73,1.3,1.3,0,0,0,.6-.15l3-1.5a1.34,1.34,0,0,0,.58-1.79A1.28,1.28,0,0,0,24.77,54.64Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M56.43,28.23l.25-3.8L55,25.87A15.12,15.12,0,1,1,74.13,45l1.44-1.65-3.8.25L68.69,47.1l3.52,3.09,3.8-.26-2.37-2.07a17.77,17.77,0,1,0-21.5-21.5L50.06,24l-.25,3.8,3.09,3.52Z"
		})
	]
});
export default SvgRotateFreeSm;
